export default {
  shopTitle: '当前商城',
  condition: '查询条件',
  uploadFile: '上传文件',
  modelTitle: '上传',
  typeOption: {
    code: 'CODE',
    upc: 'UPC',
  },
  button: {
    demo: '模板',
    upload: '上传',
  },
  status: {
    success: '成功',
    fail: '失败',
    invalid: '无效',
  },
  history: {
    table: {
      date: '日期',
      name: '名字',
      mainShop: '主商城',
      success: '成功',
      fail: '失败',
      show: '展示',
      addToFavorite: '添加到收藏夹',
      addButton: '添加',
      detail: '失败SKUs',
      detailButton: '详情',
      upload: '上传报告',
      download: '下载',
    },
    tips: {
      downloadFail: '下载失败',
    },
  },
  historyDetail: {
    modalTitle: '历史',
    table: {
      view: 'view',
      brand: '品牌',
      name: '名字',
      code: 'Code',
      upc: 'UPC',
      state: '状态',
    },
  },
  uploadHandler: '单次导入不能超过1000条',
  uploadMsg: {
    txt_1: '导入数量：单次导入不能超过1000条',
    txt_2: '成功：找到符合条件的SKU',
    txt_3: '失败：SKU在提供的条件下不可用',
    txt_4: '无效：由于空白条件，SKU不可用',
    txt_5: '*上传格式的所选条件的信息是必需的',
  },
};
